// src/components/shuffleArray.ts
export default function shuffleArray<T>(array: T[]): T[] {
  const result = [...array];  // 配列をコピーして新しい配列を作成 
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}